import { create } from "zustand";

interface SupplyKitFormState {
  open: boolean;
  kitId?: string;
}

interface SupplyKitStore {
  formState: SupplyKitFormState;
  openKitModal: (kitId?: string) => void;
  closeKitModal: () => void;
}

export const useSupplyKitStore = create<SupplyKitStore>((set) => ({
  formState: {
    open: false,
  },
  openKitModal: (kitId?: string) =>
    set({ formState: { open: true, kitId } }),
  closeKitModal: () =>
    set({ formState: { open: false, kitId: undefined } }),
}));
